<template>
  <v-card class="text-center">
    <v-btn fab fixed top right @click="$emit('close')" color="error">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <div class="display-1">{{title}}</div>
    <breast side="L" @click="side('L')" :outlined="!leftSelected"/>
    <breast side="R" @click="side('R')" :outlined="leftSelected"/>
    <v-btn dark large color="orange" @click="editFeed.both = !editFeed.both" :outlined="!editFeed.both" class="mt-3 mb-3">Both</v-btn>

    <v-container>
      <v-row>
        <v-col cols="6">
          <v-dialog
              ref="dateDialog"
              v-model="dateDialog"
              :return-value.sync="date"
              persistent
              width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                  v-on="on"
                  v-model="date"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" scrollable color="teal">
              <v-spacer></v-spacer>
              <v-btn text color="teal" @click="dateDialog = false">Cancel</v-btn>
              <v-btn text color="teal" @click="$refs.dateDialog.save(date)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="6">
          <v-dialog
              ref="timeDialog"
              v-model="timeDialog"
              :return-value.sync="time"
              persistent
              width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                  v-on="on"
                  v-model="time"
                  label="Time"
                  prepend-icon="mdi-clock-outline"
                  readonly
              ></v-text-field>
            </template>
            <v-time-picker v-if="timeDialog" v-model="time" color="teal" format="24hr">
              <v-spacer></v-spacer>
              <v-btn text color="teal" @click="timeDialog = false">Cancel</v-btn>
              <v-btn text color="teal" @click="$refs.timeDialog.save(time)">OK</v-btn>
            </v-time-picker>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>

    <v-btn color="green" @click="done" large>Done</v-btn>
  </v-card>
</template>

<script>
import Breast from './Breast';
import moment from 'moment';
import {mapActions} from 'vuex';

export default {
  name: 'FeedEditor',
  components: {Breast},
  props: ['title', 'feed'],
  data() {
    return {
      newFeed: false,
      editFeed: {startedAt: '', first: 'L', both: false},
      date: '',
      time: '12:00',
      dateDialog: false,
      timeDialog: false
    };
  },
  methods: {
    ...mapActions('feeds', [
      'addFeed'
    ]),
    side(side) {
      this.editFeed.first = side;
    },
    done() {
      const feed = Object.assign({}, this.editFeed);
      if (this.newFeed) {
        this.addFeed(feed)
            .then(() => this.$emit('saved'))
            .catch(err => this.$logger.error(err));
      } else {
        this.$logger.info('done', this.feed, feed, this.editFeed);
        this.$store.dispatch('feeds/editFeed', {
          id: this.feed.id,
          feed
        })
            .then(() => this.$emit('saved'))
            .catch(err => this.$logger.error(err));
      }
    }
  },
  watch: {
    date() {
      this.editFeed.startedAt = moment(this.date + 'T' + this.time);
    },
    time() {
      this.editFeed.startedAt = moment(this.date + 'T' + this.time);
    },
    feed() {
      this.newFeed = false;
      Object.assign(this.editFeed, this.feed);
      const dateTime = moment(this.editFeed.startedAt.toDate());
      this.date = dateTime.format('YYYY-MM-DD');
      this.time = dateTime.format('HH:mm');
    }
  },
  computed: {
    leftSelected() {
      return this.editFeed.first === 'L';
    }
  },
  created() {
    if (this.feed) {
      Object.assign(this.editFeed, this.feed);
      const dateTime = moment(this.editFeed.startedAt.toDate());
      this.date = dateTime.format('YYYY-MM-DD');
      this.time = dateTime.format('HH:mm');
    } else {
      this.newFeed = true;
      this.date = moment().format('YYYY-MM-DD');
      this.time = moment().format('HH:mm');
    }
  }
}
</script>

<style scoped>
  .display-1 {
    padding-top: 25px;
  }
</style>
